export default __webpack_public_path__ + "static/media/icon_resources.71f75de5.png";